import { defineStore } from 'pinia'
import { DepartmentOpeningHours } from '~concierge/types/DepartmentTypes'
import { ref } from 'vue'
import axios, { AxiosError } from 'axios'

const BASE_API_URL = '/api/alfred/opening-hours'

export const useDepartmentOpeningHours = defineStore({
  id: 'departmentOpeningHours',
  state: () => ({
    open: ref<boolean>(false),
    isAboutToClose: ref<boolean>(false),
    closingDetails: ref<string>(''),
    openingHours: ref<Readonly<DepartmentOpeningHours>>({})
  }),
  actions: {
    async initialize(lang: string): Promise<void> {
      try {
        const response = await axios.get(`${BASE_API_URL}?lang=${lang}`)
        this.openingHours = response.data
      } catch (error: unknown | Error | AxiosError) {
        if (axios.isAxiosError(error) && error.response) {
          throw error.response
        }
        console.error('Error when fetching departments opening hours:', error)
        throw error
      }
    }
  }
})
